export enum GA_ATRIBUTES {
  TYPE = 'data-ga-trackingtype',
  CATEGORY = 'data-ga-event-category',
  ACTION = 'data-ga-event-action',
  LABEL = 'data-ga-event-label',
}

export interface DataAttribute {
  [key: string]: string | undefined;
  [GA_ATRIBUTES.LABEL]?: string;
  [GA_ATRIBUTES.CATEGORY]?: string;
  [GA_ATRIBUTES.ACTION]?: string;
}
